import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {
  IExternalLinksService, IOpenGameLimitsOptions, IOpenOmgOptions, IOpenPendingLoginOptions, IOpenPendingPlayOptions,
  OpenLinkParams,
  OpenRichPageOptions
} from './external-links.service.interface';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";
import {ExternalLinksLegacyStrategy} from "./strategies/external-links-legacy.strategy";
import {ExternalLinksModernStrategy} from "./strategies/external-links-modern.strategy";
import {IOpenMyAccountOptions} from "./handlers/my-account/my-account.external-link-handler.interface";
import {IOpenRegistrationOptions} from "./handlers/registration/registration.external-link-handler.interface";
import {IExternalLinksProxy} from "../../../common/interfaces/external-links-proxy.interface";
import {OpenCashierOptions} from "../../../common/interfaces/cashier.service.interface";

const useModernStrategy = true;

export class ExternalLinksService extends ServiceBase implements IExternalLinksService, IExternalLinksProxy {
  constructor(services: IServiceFactoryExtended) {
    super(services);
    if(useModernStrategy) {
      this._strategy = new ExternalLinksModernStrategy(services);
    } else {
      this._strategy = new ExternalLinksLegacyStrategy(services);
    }
  }

  private readonly _strategy: IExternalLinksService;

  openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL: boolean = false): Promise<any> {
    return this._strategy.openLink(params, marketingParams, useCallbackURL);
  }

  openResponsibleGamblingLink(view?:number):void{
    this._strategy.openResponsibleGamblingLink(view);
  }

  async openMyAccount(options?: IOpenMyAccountOptions): Promise<void> {
    await this._strategy.openMyAccount(options);
  }

  async openCashier(options?:OpenCashierOptions): Promise<void> {
    await this._strategy.openCashier(options);
  }

  async openContactUs(): Promise<void> {
    await this._strategy.openContactUs();
  }

  async openOldChat(): Promise<void> {
    await this._strategy.openOldChat();
  }

  async openHelpPage(): Promise<void> {
    await this._strategy.openHelpPage();
  }

  async openDownloadApp(): Promise<void> {
    await this._strategy.openDownloadApp();
  }

  async openUploadDocument(): Promise<void> {
    await this._strategy.openUploadDocument();
  }

  async openMembership(options?: IOpenRegistrationOptions): Promise<void> {
    await this._strategy.openMembership(options);
  }

  async openSafeToPlay(): Promise<void> {
    await this._strategy.openSafeToPlay();
  }

  openRichPage(options: OpenRichPageOptions): Promise<void> {
    return this._strategy.openRichPage(options);
  }

  renderRichPageContent(): Promise<React.ReactElement> {
    return this._strategy.renderRichPageContent();
  }

  openSport(): Promise<void> {
    return this._strategy.openSport();
  }

  openInternalUrl(url: string): Promise<void> {
    return this._strategy.openInternalUrl(url);
  }
  openExternalUrl(url: string): Promise<void> {
    return this._strategy.openExternalUrl(url);
  }

  openExternalBrand(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL?: boolean): Promise<void> {
    return this._strategy.openExternalBrand(params, marketingParams, useCallbackURL);
  }

  openBankId(url: string): void {
    this._strategy.openBankId(url);
  }

  openOMG(options: IOpenOmgOptions): Promise<void> {
    return this._strategy.openOMG(options);
  }

  openForgotUserName(): Promise<void> {
    return this._strategy.openForgotUserName();
  }

  openForgotPassword(): Promise<void> {
    return this._strategy.openForgotPassword();
  }

  openPendingLogin(options: IOpenPendingLoginOptions): Promise<void> {
    return this._strategy.openPendingLogin(options);
  }

  openPendingPlay(options: IOpenPendingPlayOptions): Promise<void> {
    return this._strategy.openPendingPlay(options);
  }

  openGameLimits(options:IOpenGameLimitsOptions): Promise<void>{
    return this._strategy.openGameLimits(options);
  }
}